export default (theme) => ({
  Marker: {
    // color: theme.palette.common.white,
    // fontSize: 16,
    // fontFamily: theme.bodyFont,
    // padding: 3,
    // textAlign: "center",
    "& svg": {
      color: theme.palette.secondary.main,
      '& path': {
        stroke: theme.palette.common.white,
        cursor: "pointer",
      }
    },
    // position: "absolute",
    // top: "100%",
    // left: "50%",
    transform: "translate(-17.5px, -35px)",
  },
});
